var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM11.2801 16.2353C11.1132 16.0588 11.0297 15.8109 11.0297 15.4916V9.11345H8.81377C8.55503 9.11345 8.35472 9.04202 8.21283 8.89916C8.07094 8.7563 8 8.55882 8 8.30672C8 8.04622 8.07094 7.84874 8.21283 7.71429C8.35472 7.57143 8.55503 7.5 8.81377 7.5H15.1862C15.445 7.5 15.6453 7.57143 15.7872 7.71429C15.9291 7.84874 16 8.04622 16 8.30672C16 8.55882 15.9291 8.7563 15.7872 8.89916C15.6453 9.04202 15.445 9.11345 15.1862 9.11345H12.9703V15.4916C12.9703 15.8109 12.8868 16.0588 12.7199 16.2353C12.5613 16.4118 12.3234 16.5 12.0063 16.5C11.6891 16.5 11.4471 16.4118 11.2801 16.2353Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont);
export default __webpack_public_path__ + "static/media/font.1a489b1740b1bdd2100b0b3a4fd2c6df.svg";
export { ForwardRef as ReactComponent };